import { CartManager, CART_UPDATE_EVENT } from './cart';
import { SaleCartManager, SALE_CART_UPDATE_EVENT } from './SaleCartManager';

// Custom event for unified cart updates
export const UNIFIED_CART_UPDATE_EVENT = 'unifiedCartUpdate';

export class UnifiedCartManager {
  static _listenersSetup = false;

  // Dispatch unified cart update event
  static notifyCartUpdate() {
    window.dispatchEvent(new CustomEvent(UNIFIED_CART_UPDATE_EVENT));
  }

  // Get combined cart data
  static getUnifiedCart() {
    const rentalCart = CartManager.getCart();
    const salesCart = SaleCartManager.getCart();

    return {
      rental: rentalCart,
      sales: salesCart,
      hasRental: rentalCart.length > 0,
      hasSales: salesCart.length > 0,
      isEmpty: rentalCart.length === 0 && salesCart.length === 0
    };
  }

  // Get total item count across both carts
  static getTotalItemCount() {
    const rentalCount = CartManager.getTotalItems();
    const salesCount = SaleCartManager.getItemCount();
    return rentalCount + salesCount;
  }

  // Setup listeners to propagate updates from individual carts
  static setupListeners() {
    // Only setup listeners once
    if (this._listenersSetup) return;
    this._listenersSetup = true;

    // Listen to rental cart updates
    window.addEventListener(CART_UPDATE_EVENT, () => {
      this.notifyCartUpdate();
    });

    // Listen to sales cart updates
    window.addEventListener(SALE_CART_UPDATE_EVENT, () => {
      this.notifyCartUpdate();
    });
  }
}
